import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Cart from "./components/Cart";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import ComingSoon from "./pages/ComingSoon";
import { CartProvider } from "./context/CartContext";
import "./App.css";

const isProduction = process.env.NODE_ENV === "production";

function App() {
  if (isProduction) {
    return <ComingSoon />;
  }

  return (
    <Router>
      <CartProvider>
        <div className="App">
          <Navbar />
          <Cart />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;
